export enum MinorCodeType {
  Cost = 1,
  Sale = 2,
  Deposit = 3,
  Loan = 4,
  Recoverable = 5,
  Other = 6,
  'COS Alloc' = 7
}

export enum MinorCodeCategory {
  Base = 0,
  Option = 1,
  Warranty = 2,
  Misc = 3
}
